<template>
  <div>
    <b-modal id="zalo-list-user-modal" ref="zalo-list-user-modal" title="Danh sách người dùng Zalo" size="xl"
      :hide-header-close="false" :no-close-on-backdrop="true" @cancel="resetModal" @hide="resetModal" hide-footer>
      <b-overlay>
        <b-container class="p-0">
          <form ref="form">
            <b-row>
              <b-col>
                <b-row class="mt-3">
                  <!-- <b-col cols="5">
                    <basic-input label="Tìm kiếm" placeholder="Nhập tìm kiếm theo tên" name="search"
                      v-model="this.name" @input="handleSearchUpdate" />
                  </b-col> -->

                  <!-- <b-col cols="3">
                    <b-button class="btn btn-success ml-2" type="button" label="Tìm kiếm" style="margin-top:20px;">Tìm kiếm</b-button>
                  </b-col> -->
                  <b-col cols="3">
                    <basic-select label="Trạng thái" placeholder="Follow hoặc Unfollow" name="follow"
                      :options="followerStatus" track-by="value" value-label="text"
                      @update:value="handleFilterStatus" />
                  </b-col>
                  <b-col cols="3">
                    <basic-input label="Nhập tên" placeholder="Nhập tên người dùng"
                      v-model="searchNameText"></basic-input>
                  </b-col>
                </b-row>
                <template-table :column="column" :data="listZaloDetails" :paging="paging" :tableAction="false"
                  :selectAction="false" :searchAction="false" boundary="window">
                  <template v-slot:body="{ item }">
                    <td>
                      <div class="grap-info">
                        <avatar size="70px" :src="item.avatar" :rounded="true" />

                        <div class="d-flex flex-column ml-3">
                          <p class="mb-0 module-list-page__body__updater-name">
                            {{ item.display_name }}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td :style="{ color: item.user_is_follower === 'true' ? 'green' : 'red' }">
                      {{ followContent(item.user_is_follower) }}
                    </td>
                    <td>
                      {{ item.user_last_interaction_date }}
                    </td>
                    <td v-if="item.shared_info.phone !== null" style="color: green;font-weight: bold;">
                      Đã chia sẻ
                    </td>
                    <td v-else>
                      <b-button type="button" @click="sendOaRequest(item.user_id)">
                        <span class="svg-icon">
                          <inline-svg src="/media/svg/icons/Neolex/Basic/send.svg" />
                        </span>
                        <p>Gửi yêu cầu{{ item.request_count > 0 ? ` lần ${item.request_count}` : '' }}</p>
                      </b-button>
                    </td>

                    <td>
                      <b-button class="btn btn-success ml-2" type="button" @click="showModalCreateGroup(item)">
                        Tạo nhóm
                      </b-button>
                    </td>
                  </template>
                </template-table>
                <div class="d-flex justify-content-end align-items-center mt-3">
                  <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancel" tabindex="0">
                    Thoát
                  </b-button>
                  <b-button class="btn btn-success ml-2" href="#" @click.stop="handleRefresh" tabindex="0">
                    <span class="svg-icon">
                      <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
                    </span>
                    Làm mới
                  </b-button>
                  <!-- <b-button class="btn btn-success ml-2" type="button" @click="showModalCreate">
                    <span class="svg-icon">
                      <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
                    </span>
                    Thêm mới
                  </b-button> -->
                </div>
              </b-col>
            </b-row>
          </form>
        </b-container>
      </b-overlay>

      <template #modal-footer>
        <!-- Your modal footer buttons go here -->
      </template>
    </b-modal>

    <b-modal id="create-group-modal" ref="create-group-modal" title="Thông tin của nhóm" size="sd" @ok="handleSuccessOk"
      hide-footer>
      <b-container>
        <b-row>
          <b-form>
            <b-row>
              <b-col cols="6">
                <b-form-group id="group-name-group" label="Tên nhóm Zalo" label-for="group-name">
                  <b-form-input id="group-name" v-model="groupName" placeholder="Nhập tên nhóm Zalo"
                    required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <basic-select label="Coach" placeholder="--- Chọn coach ---" name="coach" :solid="false"
                  :allowEmpty="true" :options="coachesList" track-by="zaloUserId" value-label="fullNameSearch"
                  v-model="coachSupportId" />

              </b-col>
            </b-row>


            <b-row v-if="this.selectedItem != null">
              <b-col cols="6">
                <p class="mb-0 module-list-page__body__updater-name"> Khách hàng </p>

                <div class="grap-info">

                  <avatar size="70px" :src="this.selectedItem.avatar" :rounded="true" />

                  <p class="mb-0 module-list-page__body__updater-name" style="font-weight: bold">

                    {{ this.selectedItem.display_name }}
                  </p>
                </div>

              </b-col>
              <b-col cols="6">
                <div v-if="this.selectedItem.shared_info.phone != null">

                  <p class="mb-0 module-list-page__body__updater-name">Thông tin chi tiết</p>


                  <b-card>
                    <b-card-text>
                      <p><strong>Address:</strong> {{ this.selectedItem.shared_info.address }}</p>
                      <p><strong>City:</strong> {{ this.selectedItem.shared_info.city }}</p>
                      <p><strong>District:</strong> {{ this.selectedItem.shared_info.district }}</p>
                      <p><strong>Phone:</strong> {{ this.selectedItem.shared_info.phone }}</p>
                      <p><strong>Name:</strong> {{ this.selectedItem.shared_info.name }}</p>
                    </b-card-text>
                  </b-card>
                </div>

                <p v-else>Chưa chia sẻ thông tin</p>
              </b-col>
            </b-row>



          </b-form>
        </b-row>
      </b-container>
      <!-- <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancelSuccess" tabindex="0">
          Đóng
        </b-button>
        <b-button class="btn btn-success ml-2" type="button" @click="showModalCreate">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Tạo nhóm
        </b-button>
      </div> -->

      <b-row class="mt-3 mb-3">
        <b-col>
          <div>
            Hạn mức nhóm còn lại:
            <strong>{{ this.filterStatus.length }}</strong>
          </div>
        </b-col>
        <b-col>
          <div>
            Tổng nhóm đã tạo:
            <strong>{{ this.filterStatusAvailabel.length }}</strong>
          </div>
        </b-col>
      </b-row>

      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancelSuccess" tabindex="0">
          Thoát
        </b-button>
        <b-button class="btn btn-success ml-2" href="#" @click.stop="handleUpdate" tabindex="0">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/refresh-ccw.svg" />
          </span>
          Cập nhật hạn mức
        </b-button>

        <b-button class="btn btn-success ml-2" href="#" @click.stop="showModalCreate" tabindex="0"
          :disabled="isSubmitting">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Tạo nhóm
        </b-button>
      </div>

    </b-modal>

    <b-modal id="detail-modal" ref="detail-modal" title="Thông tin của nhóm" size="xl" @ok="handleSuccessOk"
      hide-footer>
      <b-container>
        <row>
          <b-overlay>
            <b-container class="p-0">
              <form ref="form">
                <b-row>
                  <b-col>
                    <template-table :column="columnDetail" :data="this.zaloGroupDetail" :paging="paging"
                      :tableAction="false" :selectAction="false" :searchAction="false" boundary="window">
                      <template v-slot:body="{ item }">
                        <!-- <td v-if="!item.oa_id"> -->
                          <td>
                          <div class="grap-info">
                            <avatar size="100px" :src="item.avatar" :rounded="true" />
                            <div class="d-flex flex-column ml-3">
                              <p style="font-size: 16px">
                                {{ item.name }}
                              </p>
                            </div>
                          </div>
                        </td>

                        <!-- <td v-if="!item.oa_id"> -->
                          <td>
                          {{ item.user_id }}
                        </td>
                        <!-- <td style="margin-top: 40px; display: block" v-if="!item.oa_id"> -->
                             <!-- <td style="margin-top: 40px; display: block">
                          <div @mouseover="hovered = true" @mouseleave="hovered = false" style="display: inline-block">
                            <basic-select v-if="
                              !listExisted.some(
                                (x) => x.zaloUserId === item.user_id,
                              )
                            " placeholder="--- Chọn số ---" name="phoneListMapping" :options="phoneListMapping"
                              value-label="text" track-by="text" :multiple="false" v-model="selectedPhone"
                              :disabled="isDisabled" />
                            {{ getPhoneNumber(item.user_id) }}
                          </div>
                        </td> -->

                        <!-- <td v-if="!item.oa_id"> -->
                          <!-- <td>
                          <b-button v-if="
                            !listExisted.some(
                              (x) => x.zaloUserId === item.user_id,
                            )
                          " class="btn btn-success ml-3" type="button" @click="
                            submitLink(
                              item.user_id,
                              splitSelectedPhone(item.user_id),
                            )
                            ">
                            Liên kết
                          </b-button>

                          <b-button v-if="
                            listExisted.some(
                              (x) => x.zaloUserId === item.user_id,
                            )
                          " class="btn btn-inactive ml-3" type="button" @click="showPopupUnLink(item.user_id)">
                            Hủy liên kết
                          </b-button>
                        </td> -->
                      </template>
                    </template-table>
                  </b-col>
                </b-row>
              </form>
            </b-container>
          </b-overlay>
        </row>
      </b-container>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button class="btn btn-plain ml-2" href="#" @click.stop="cancelItem" tabindex="0">
          Quay lại
        </b-button>
      </div>
    </b-modal>



    <ZaloModal ref="zalo-modal" @call-refresh-list="getGroupOA" />
    <ZaloEditModal ref="zalo-edit-modal" @call-refresh-list="getGroupOA" :groupItem="groupItem" />
  </div>

</template>
<script>
import ZaloModal from './ZaloModal.vue';
import ZaloEditModal from './ZaloEditModal.vue';

export default {
  components: {
    ZaloModal,
    ZaloEditModal,
  },
  name: 'ZaloListModal',
  props: {
    coursesList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    'paging.page'() {
      this.getZaloListDetail();
      console.log('paging.page', this.paging.page);
    },
    'paging.pageSize'() {
      this.getZaloListDetail();
      console.log('paging.pageSize', this.paging.pageSize);
    },
    'searchNameText'() {
      console.log('searchNameText', this.searchNameText);
      return this.listZaloDetails.filter(item =>
        this.searchNameText
          ? item.display_name?.toLowerCase().includes(this.searchNameText.toLowerCase())
          : true
      );
    },

  },
  computed: {
    isDisabled() {
      return !this.hovered;
    },
    //   filteredListZaloDetails() {
    //   console.log("Search Text:", this.searchText);
    //   console.log("Original List:", this.listZaloDetails);

    //   if (!this.searchText) return this.listZaloDetails;

    //   const filtered = this.listZaloDetails.filter(item => {
    //     console.log("Checking:", item.name);
    //     return item.name?.toLowerCase().includes(this.searchText.toLowerCase());
    //   });

    //   console.log("Filtered List:", filtered);
    //   return filtered;
    // }

  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 100,
      },
      data: '',
      selectedPackage: '',
      coursesId: '',
      column: [
        {
          key: 'name',
          label: 'Người dùng Zalo',
          sortable: false,
          style: {
            width: '20%',
          },
        },
        // {
        //   key: 'actionDropdown',
        //   label: '',
        //   sortable: false,
        //   style: {
        //     width: '5%',
        //   },
        // },
        {
          key: 'user_is_follower',
          label: 'Follow OA',
          sortable: false,
          style: {
            width: '5%',
          },
        },
        {
          key: 'user_last_interaction_date',
          label: 'Ngày tương tác cuối',
          sortable: false,
          style: {
            width: '15%',
          },
        },
        {
          key: 'sharedInformation',
          label: 'Thông tin',
          sortable: false,
          style: {
            width: '10%',
          },
        },
        {
          key: 'ButtonCreateGroup',
          label: 'Action',
          sortable: false,
          style: {
            width: '10%',
          },
        },
        // {
        //   key: 'createGroup',
        //   label: 'Tạo nhóm',
        //   sortable: false,
        //   style: {
        //     width: '10%',
        //   },
        // },
        // {
        //   key: 'group_description',
        //   label: 'Mô tả nhóm',
        //   sortable: false,
        //   style: {
        //     width: '25%',
        //   },
        // },
        // {
        //   key: 'group_link',
        //   label: 'Link tham gia nhóm',
        //   sortable: false,
        // },
      ],
      columnDetail: [
        {
          key: 'name',
          label: 'Tên thành viên',
          sortable: false,
          style: {
            width: '45%',
          },
        },

        {
          key: 'user_id',
          label: 'User Zalo Id',
          sortable: false,
          style: {
            width: '15%',
          },
        },

        // {
        //   key: 'phone_group',
        //   label: 'Tài khoản liên kết',
        //   sortable: false,
        //   style: {
        //     width: '25%',
        //   },
        // },
        // {
        //   key: 'mapping_phone',
        //   label: 'Liên kết',
        //   sortable: false,
        //   style: {
        //     width: '15%',
        //   },
        // },
      ],

      coach_id: '',
      isSubmitting: false,
      zaloGroup: [],
      zaloGroupDetail: [],
      phoneListMapping: [],
      selectedPhone: null,
      listExisted: [],
      parts: [],
      groupItem: [],
      hovered: false,
      isLoading: false,
      listZaloDetails: [],
      selectedItem: null,
      coachesList: [],
      groupName: 'DiaB - Group Health Coach',
      isModalVisible: false,
      filterStatusAvailabel: [],
      filterStatus: [],
      coachSupportId: [],
      followerStatus: [
        { text: 'Follow', value: true },
        { text: 'Unfollow', value: false },
      ],
      searchNameText: null
    };
  },

  async created() {
   // await Promise.all([this.getZaloListDetail(), this.getListPhoneNotMap()]);

  },
  mounted() {
  },
  methods: {


    changeText(item) {
      if (item.includes('Chung')) {
        return 'Group chung';
      } else {
        return 'Group Health Coach';
      }
    },

    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength
        ? text.substring(0, maxLength) + '...'
        : text;
    },
    cancelItem() {
      this.$refs['detail-modal'].hide();
    },
    async viewItem(group_id) {
      console.log("group_id", group_id);
      this.$store.commit('context/setLoading', true);

      try {
        const params = {
          group_id: group_id,
          offset: 0,
          count: 50,
        };

        //  const course = this.coursesList.find((x) => x.zaloGroupId === group_id);
        //   if (course !== null) {
        //     this.coursesId = course.id;
        //     this.getPhoneList(this.coursesId);
        //   } else {
        //     this.$toastr.e({
        //       title: 'Warning',
        //       msg: 'Nhóm zalo chưa được chỉ định cho khóa',
        //     });
        //     return;
        //   }

        const response = await this.$api.get('/ZaloZnsLog/DetailGroup', {
          params,
        });

        this.zaloGroupDetail = response.data.members;
        //  this.paging.total = response.data.total;

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Lấy danh sách nhóm thành công.',
        });
        this.$refs['detail-modal'].show();
      } catch (error) {
        this.$toastr.w({
          title: 'Cảnh báo!',
          msg: 'Nhóm chưa được chỉ định vào khóa.',
        });
        console.error(error);
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async deletedGroup(group_id) {
      try {
        // Construct the JSON body
        const body = {
          group_id: group_id,
        };

        // Make the API call with JSON body
        await this.$api.post('/ZaloZnsLog/DeleteGroupOa', body, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        // Display success message
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Nhóm zalo được xóa thành công.',
        });
      } catch (error) {
        // Display error message
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error,
        });
        this.isSubmitting = false;
      }
    },
    async showPopupDeleteStatus(group_id) {
      this.$swal({
        title: 'Xác nhận',
        text: `Bạn có chắc chắn muốn xóa nhóm không?\n Không thể quay lại nhóm sau khi đã xóa`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            await this.deletedGroup(group_id);
            await this.getGroupOA();
          }
        }.bind(this),
      );
    },

    async editItem(item) {
      this.groupItem = item;
      this.$refs['zalo-edit-modal'].show();
    },

    async showPopupUnLink(user_id) {
      this.$swal({
        title: 'Xác nhận',
        text: `Bạn có chắc chắn muốn bỏ liên kết tài khoản không?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            await this.submitUnLink(user_id, this.splitSelectedPhone(user_id));
          }
        }.bind(this),
      );
    },
    showModalCreate() {
      this.$swal({
        title: 'Xác nhận',
        text: `Bạn đang thao tác tạo nhóm zalo cá nhân với khách hàng`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            //   await this.submitUnLink(user_id, this.splitSelectedPhone(user_id));
            // console.log("confirm")
            this.handleSubmit();
          }
        }.bind(this),
      );

    },

    getPhoneNumber(user_id) {
      const filterPhone = this.listExisted.find((x) => x.zaloUserId == user_id);
      return filterPhone ? filterPhone.phoneNumber : null;
    },
    async getPhoneList(courseId) {
      const response = await this.$api.get(
        `CustomerReceives/MappingZalo?courseId=${courseId}`,
      );
      this.phoneListMapping = response;
      await this.getListAccount();
    },

    async getListAccount() {
      const respone = await this.$api.get(`/Account/ZaloIdExist`);
      this.listExisted = respone
        .filter((item) => item.zaloUserId != null)
        .map((item) => {
          return {
            zaloUserId: item.zaloUserId,
            phoneNumber: item.phoneNumber,
          };
        });
    },

    splitSelectedPhone(user_id) {
      // Check if selectedPhone exists, and split it if it does
      if (this.selectedPhone) {
        this.parts = this.selectedPhone.split('|');

        // Return the second part if it exists
        if (this.parts[1]) {
          return this.parts[1];
        }
      }

      // If parts[1] is not found, try to get the phone number using the user_id
      const phoneNumber = this.getPhoneNumber(user_id);

      // Return the phone number or null if not found
      return phoneNumber || null;
    },

    async submitLink(user_id, phone) {
      try {
        this.$store.commit('context/setLoading', true);

        const response = await this.$api.get(
          `/CustomerReceives/MappingZaloPortal?user_id=${user_id}&phone=${phone}`,
        );

        if (response.data.error) {
          this.$toastr.e({
            title: 'Thất bại!',
            msg: response.message || 'Đã xảy ra lỗi không xác định.',
          });
          return;
        }

        await this.getListAccount();

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Liên kết thành công.',
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Thất bại!',
          msg: error.message || 'Liên kết không thành công.',
        });
      } finally {
        // Reset the loading state
        this.$store.commit('context/setLoading', false);
      }
    },

    async submitUnLink(user_id, phone) {
      this.$store.commit('context/setLoading', true);

      try {
        await this.$api.get(
          `/CustomerReceives/UnMappingZaloPortal?user_id=${user_id}&phone=${phone}`,
        );

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Hủy liên kết thành công.',
        });
      } catch {
        this.$toastr.e({
          title: 'Lỗi',
          msg: 'Hủy liên kết thất bại.',
        });
      } finally {
        await this.getListAccount();
        this.$store.commit('context/setLoading', false);
      }
    },

    async getListPhoneNotMap() {
      const coachList = await this.$api.get('/Account/ZaloIdCoachs');
      this.coachesList = coachList.data;
    },

    async handleFilterStatus(value) {
      this.isFollow = value;
      console.log("this.isFollow", this.isFollow);
      await this.getZaloListDetail();
    },

    async getZaloListDetail() {
      const params = {
        offset: (this.paging.page - 1) * this.paging.pageSize,
        count: this.paging.pageSize,
        isfollow: this.isFollow,
      };

      try {
        this.$store.commit('context/setLoading', true);

        const response = await this.$api.get('/ZaloZnsLog/list-user', {
          params,
        });
        this.listZaloDetails = response.data.details;
        this.paging.total = response.data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Thất bại!',
          msg: error.message,
        });
      } finally {
        // Reset the loading state
        this.$store.commit('context/setLoading', false);
      }
    },

    checkConditionCreateGroup(item) {
      const currentDate = new Date();
      const lastInteractionDate = new Date(item.user_last_interaction_date);
      const diffTime = Math.abs(currentDate - lastInteractionDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (item.user_is_follower === 'true' && diffDays <= 7) {
        return 'Có tương tác'
      }
      else {
        return ''
      }
    },

    followContent(item) {
      console.log("item", item)
      if (item == 'true') {
        return 'follow';
      }
      else {
        return 'unfollow';
      }

    },
    async getCoachList() {
      const coachList = await this.$api.get('/Account/ZaloUsers');
      this.coachesList = coachList.data;
    },

    show() {
      this.$refs['zalo-list-user-modal'].show();
    },
    hide() {
      this.$refs['zalo-list-user-modal'].hide();
    },

    async getDetailGroupOA(group_id) {
      const body = {
        group_id: group_id,
      };

      // Make the API call with JSON body
      const response = await this.$api.post('/ZaloZnsLog/DetailGroup', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      this.zaloGroupDetail = response.data;
    },
    async sendOaRequest(item) {
      this.$store.commit('context/setLoading', true);
      try {
        const response = await this.$api.post('/ZaloZnsLog/SharedInformation', null, {
          params: { user_id: item },
          headers: {
            'Content-Type': 'application/json',
          },
        });

        console.log("response", response)

        if (response.error) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: response.message || 'Gửi yêu cầu chia sẻ thông tin thất bại.',
          });

        } else {
          this.$toastr.s({
            title: 'Thành công!',
            msg: 'Gửi yêu cầu chia sẻ thông tin thành công.',
          });
          this.loadData();
        }
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Gửi yêu cầu chia sẻ thông tin thất bại.',
        })
        this.$store.commit('context/setLoading', false);

      }
      this.$store.commit('context/setLoading', false);

    },




    async getGroupOA() {
      this.$store.commit('context/setLoading', true);
      try {
        const response = await this.$api.get(`/ZaloZnsLog/GetGroupOA`);
        this.zaloGroup = response.data.groups;
        this.paging.total = response.data.total;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },

    handleCancelSuccess() {
      //   this.$refs['success-modal'].hide();
      this.$refs['create-group-modal'].hide();

      this.resetModal();
    },
    handleCancel() {
      this.hide();
    },
    handleSuccessOk() {
      this.hide();
      this.resetModal();
    },
    async handleRefresh() {
      this.isSubmitting = false;
      await this.getGroupOA();
    },
    async showModalCreateGroup(item) {
      console.log("this item", item)
      await this.loadData();
      this.selectedItem = item;
      this.$refs['create-group-modal'].show();
    },
    async handleUpdate() {
      await this.loadData();
      this.$toastr.s({
        title: 'Thành công!',
        msg: 'Đã cập nhật hạn mức tạo nhóm',
      });
    },

    async loadData() {
      try {
        const body = {
          quota_owner: 'OA',
          quota_type: 'sub_quota',
        };

        const response = await this.$api.post('/ZaloZnsLog/GetAssetOA', body, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        this.filterStatusAvailabel = response.data.filter(
          (item) => item.status === 'used',
        );
        this.filterStatus = response.data.filter(
          (item) => item.status === 'available',
        );
      } catch (error) {
        console.log(error);
      }
      this.getZaloListDetail();
    },

    async handleSubmit() {
      const groupName = this.groupName;
      // const groupDescription = this.form.group_description.value;
      //  const groupDescriptionName = 'NHÓM KHÁCH HÀNG VÀ OA DIAB';

      this.isSubmitting = true;

      if (this.filterStatus.length === 0) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Đã đạt hạn mức tạo nhóm. Vui lòng cập nhật lại hạn mức !!!',
        });
        this.isSubmitting = false;
        return;
      }

      if (!groupName) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Tên nhóm không được để trống.',
        });
        this.isSubmitting = false;
        return;
      }

      if (groupName.trim().length >= 200) {
        // Check if group description is less than 10 characters
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Vui lòng chọn tên dưới 200 ký tự',
        });
        this.isSubmitting = false;
        return;
      }

      if (typeof groupName !== 'string' || groupName.trim().length < 10) {
        // Check if group description is less than 10 characters
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Tên nhóm là text và có ít nhất 10 ký tự.',
        });
        this.isSubmitting = false;
        return;
      }

      try {
        // Construct the JSON body
        const body = {
          group_name: groupName,
          group_description: 'Khách hàng và OA DIAB',
          asset_id: 'd20c9bd4888961d73898',
          member_user_ids: [this.coachSupportId, this.selectedItem.user_id],
        };

        // Make the API call with JSON body
        const response = await this.$api.post(
          '/ZaloZnsLog/CreateGroupOA',
          body,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        this.data = response.data;
        // Check if there is an error in the response
        if (response.data.error) {
          this.$toastr.e({
            title: 'Lỗi !',
            msg: 'Zalo Id không hợp lệ.',
          });
          this.isSubmitting = false;
        }

        // Display success message
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Nhóm zalo được tạo thành công.',
        });

        // Show success modal
        //    this.resetModal();
        //     this.$refs['success-modal'].show();
      } catch (error) {
        // Display error message
        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Người dùng chưa tương tác hoặc đã có lỗi xảy ra',
        });
        this.isSubmitting = false;
      } finally {
        await this.loadData();
        // this.form.lock_send_msg = this.form.group_description.value === 'common';
        await this.assginZaloAdmin(this.data.group_id, this.coachSupportId);
        //   this.$emit('call-refresh-list');
        //     this.$refs['zalo-list-modal'].getGroupOA();
        //  this.hide();
        //  this.isSubmitting = TRUE;

      }
    },
    async assginZaloAdmin(group_id, group_description) {
      //    this.form.lock_send_msg = this.lockmessage === 'common';

      'https://hcm03.vstorage.vngcloud.vn/v1/AUTH_e575ba7d5712488190aef827d0bcface/Image%20Website/logo-diab-offical';
      const zaloChooseCoach =
        'Type Group: ' +
        group_description +
        '\nHealth Coach: ' +
        [...this.member_user_name] +
        '\nIDs: ' +
        [...this.member_user_ids];
      const body = {
        group_id: group_id,
        group_avatar: 'https://hcm03.vstorage.vngcloud.vn/v1/AUTH_e575ba7d5712488190aef827d0bcface/Image%20Website/logo-diab-offical',
        lock_send_msg: false,
        join_appr: false,
        enable_msg_history: true,
        enable_link_join: true,
        group_description: zaloChooseCoach,
      };
      return this.$api.post('/ZaloZnsLog/UpdateZaloGroupInfo', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },


  },
};
</script>
<style scoped>
.no-footer .modal-footer {
  display: none;
}

.group-name {
  display: inline-block;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.bold-label {
  font-weight: bold;
  color: #333;
  text-align: left;
}

button.btn.btn-secondary.collapsed {
  margin: -15px;
}

button.btn.btn-secondary.not-collapsed {
  margin: -15px;
}

.grap-info {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 20px;
  align-items: center;
  width: 100%;
}

.multiselect__clear {
  display: none !important;
}

.basic-select-hover {
  cursor: pointer;
  /* Change cursor to indicate interactivity */
  border: 1px solid #ccc;
  /* Optional styling */
}

.basic-select-hover:hover {
  border-color: #007bff;
  /* Change border color on hover */
}
</style>
